module.exports = __webpack_public_path__ + "static/media/icon_02.5b22d487.png";